import {
  HeroTitleText,
  HeroSubtitleText,
  HeroButton,
  ButtonText,
  LinkTag,
  BaseTypography,
} from './styles';
import {
  MobileBannerButtonCopy,
  DesktopBannerButtonCopy,
  PromoButton,
  PromoTypography,
} from 'components/Homepage/styles';
import { GreenLink } from 'components/theme/GreenLink';

// Desktop Banner
export const DesktopBannerCopy = () => (
  <PromoTypography
    variant="p1Bold"
    sx={{
      display: {
        xs: 'none',
        lg: 'block',
      },
    }}
  >
    Up to 700k new users now on StartEngine.
  </PromoTypography>
);

export const ExploreDesktopBannerCopy = () => (
  <PromoTypography
    variant="p1Bold"
    sx={{
      display: {
        xs: 'none',
        lg: 'block',
      },
    }}
  >
    Raise your next round on StartEngine.
  </PromoTypography>
);

export const BannerButton = () => (
  <a
    href="https://www.startengine.com/raise-capital"
    style={{
      textDecoration: 'none',
    }}
  >
    <PromoButton variant="outlined" color="success">
      <MobileBannerButtonCopy variant="p2Bold">Apply</MobileBannerButtonCopy>
      <DesktopBannerButtonCopy variant="p2Bold">Apply Now</DesktopBannerButtonCopy>
    </PromoButton>
  </a>
);

// Mobile Banner

export const MobileBannerCopy = () => (
  <PromoTypography
    variant="p1Bold"
    sx={{
      display: {
        xs: 'block',
        lg: 'none',
      },
    }}
  >
    Acquisition complete. Join us today.
  </PromoTypography>
);

export const ExploreMobileBannerCopy = () => (
  <PromoTypography
    variant="p1Bold"
    sx={{
      display: {
        xs: 'block',
        lg: 'none',
      },
    }}
  >
    Raise your next round on StartEngine.
  </PromoTypography>
);

export const HeroTitle = () => (
  <HeroTitleText
    variant="h5"
    sx={{
      width: {
        xs: '82%',
        lg: '100%',
      },
    }}
  >
    WE JUST BOUGHT SEEDINVEST
  </HeroTitleText>
);

export const HeroSubheading = () => (
  <HeroSubtitleText
    variant="h7"
    maxWidth="524px"
    sx={{
      width: {
        xs: '96%',
        sm: '100%',
      },
    }}
  >
    It&apos;s official. We tied the knot and created one of the biggest crowdfunding networks out
    there: 1.7M prospective investors, $1.1B raised in combined capital.* Join us for the next
    chapter in startup investing.
  </HeroSubtitleText>
);

export const HeroAdditionalInformation = () => <div />;

export const HeroButtonCopy = () => (
  <LinkTag href="https://invest.startengine.com/">
    <HeroButton
      variant="contained"
      color="secondary"
      sx={{
        background: 'rgb(24, 92, 101) !important',
        height: {
          sm: '36px',
          md: '48px',
        },
        mt: {
          xs: '42px',
          sm: '32px',
        },
        width: {
          xs: '87%',
          sm: '50%',
        },
      }}
    >
      <ButtonText data-cy="invest-now-button">Become a StartEngine Shareholder</ButtonText>
    </HeroButton>
  </LinkTag>
);

// Hero Disclosure

export const HeroDisclosure = () => (
  <BaseTypography
    sx={{
      maxWidth: '597px',
    }}
  >
    Reg A+ offering made available through StartEngine Inc. No broker-dealer or intermediary
    involved in offering. This investment is speculative, illiquid, and involves a high degree of
    risk, including the possible loss of your entire investment. Please see the{' '}
    <GreenLink
      link="https://www.startengine.com/blog/offering-circular/"
      text="Supplements"
      data-cy="supplement-link"
    />
    ,{' '}
    <GreenLink
      link="https://www.sec.gov/Archives/edgar/data/1661779/000110465922063079/tm2215725d1_253g2.htm"
      text="Offering Circular"
      data-cy="offering-circular-link"
    />{' '}
    and{' '}
    <GreenLink
      link="https://www.sec.gov/Archives/edgar/data/1661779/000110465922032551/tm226245d2_partiiandpartiii.htm#a_002"
      text="Related Risks"
      data-cy="related-risks-link"
    />{' '}
    for more information. Kevin O’Leary is a paid spokesperson for StartEngine. Read the 17-b
    disclosure <GreenLink link="https://www.startengine.com/17b" text="here" data-cy="17-b-link" />
    .
    <br /> <br />
    *Includes funds raised via Reg. CF and Reg. A+ through StartEngine&apos;s funding portal and
    broker-dealer combined, as well as StartEngine&apos;s OWN raise.
  </BaseTypography>
);
